import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/years-to-millionaire-calculator',
  component: () => import('../../routes/YearsToMillionaire.svelte'),
  card: {
    id: 'years-to-millionaire',
    title: 'Years to Millionaire',
    description: 'Find out how long it takes to become a millionaire based on your savings and investment returns.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/years-to-millionaire-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Years to Millionaire Calculator – How Long to Reach $1 Million',
    description: 'Calculate how many years it takes to become a millionaire based on your starting savings, monthly contributions, and expected investment returns. See year-by-year growth breakdown.',
  },
};

export default meta;
